import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import {
  BlockType,
  ObsoleteBlockType,
  SpecialBlockType,
  UnknownBlockType,
} from '../base/baseSchema.js';

export const FLOW_TEMPLATE_BLOCK_TYPE_COMPATIBILITY: FlowDefinitionBlockCompatibilityByBlockType = {
  [BlockType.Start]: FlowDefinitionBlockTypeCompatibility.Required,
  [BlockType.Output]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SubFlowV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.IteratorV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Repeat]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Conditional]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Switch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ScriptedFlow]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Text]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FilterList]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.UpdateFlowConfig]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.LlmPrompt]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Evaluation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.MedicalNecessityCheck]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Fhir]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.OcrV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.InformationExtraction]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.VoiceCallV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.VoiceTranscribe]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HieQueryDocuments]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HieGetDocuments]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.WaitForFormCompletion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitForAvailableSchedulingSlot]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Conversation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.AdvancedFhir]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.HCCAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentTemplate]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GenerateFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.PatientDataStore]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Rest]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.Form]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FormV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetFormSet]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetInsurances]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SendEmail]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SendSms]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.Fax]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HumanTask]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [BlockType.UpdateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Hl7]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Mirth]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.MontageOnBase]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.RealTimeEligibility]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.InsuranceCard]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FileConversion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitForSignal]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Callback]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.CareGapAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentExtract]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetPatient]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetPatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetProvider]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ExportExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ExportTextToBucket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreateEncounterSummary]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreatePatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.AsynchronousExportJob]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentSearch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetSftpFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ServiceReview]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [SpecialBlockType.SkillV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  // Retired blocks
  [BlockType.AuthorizationSubmission]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Wait]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.IteratorV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.SubFlowV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.VoiceCall]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Ocr]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.RestApiClassicAuthorization]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.Scheduling]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [BlockType.AsynchronousExtractJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // Obsolete blocks
  [ObsoleteBlockType.ObsoleteApiSubmissions]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [ObsoleteBlockType.ObsoleteGetEncounterSummary]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [ObsoleteBlockType.ObsoleteHumanReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [ObsoleteBlockType.ObsoleteSkill]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [ObsoleteBlockType.ObsoleteSendToLabelboxForReview]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [UnknownBlockType.Unknown]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
};
